import { useProjectStore } from "../state/projectStore";
import { useT } from "../i18n";

// Compact analysis: tempo + key in a single high-visibility card (mode/scale and descriptions removed).
export function AnalysisPanel() {
  const t = useT();
  const analysis = useProjectStore((s) => s.analysis);
  const headerTempo = useProjectStore((s) => s.headerTempo);
  if (!analysis) return null;

  const keyLabel = `${analysis.key.tonic} ${analysis.key.quality === "minor" ? "minor" : "major"}`;

  return (
    <section className="section">
      <h2>{t("analysis.title")}</h2>
      <div className="analysis-grid">
        <div className="acard">
          <div className="akey">{t("analysis.tempo")}</div>
          <div className="aval mono">♩={headerTempo ?? "—"}</div>
        </div>
        <div className="acard">
          <div className="akey">{t("analysis.key")}</div>
          <div className="aval">{keyLabel}</div>
        </div>
      </div>
    </section>
  );
}
